
import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Linkedin, Twitter } from 'lucide-react';
import { useCompanyStore } from '@/lib/store';
interface SocialLink {
  platform: string;
  url: string;
  icon: React.ReactNode;
}
const Footer = () => {
  const {
    siteSettings
  } = useCompanyStore();

  // Default empty links if none are set yet
  const socialLinks: SocialLink[] = [{
    platform: 'Instagram',
    url: siteSettings?.instagramUrl || '#',
    icon: <Instagram className="w-5 h-5" />
  }, {
    platform: 'Twitter',
    url: siteSettings?.twitterUrl || '#',
    icon: <Twitter className="w-5 h-5" />
  }, {
    platform: 'LinkedIn',
    url: siteSettings?.linkedinUrl || '#',
    icon: <Linkedin className="w-5 h-5" />
  }];

  // Split the page links into two columns
  const pageLinksColumnOne = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'Add Review',
    path: '/add-review'
  }, {
    name: 'Jobs',
    path: 'https://greenflags.com.au'
  }];
  const pageLinksColumnTwo = [{
    name: 'In the media',
    path: '/in-the-media'
  }, {
    name: 'How it works',
    path: '/how-it-works'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <footer className="py-12 px-6 bg-redflags-dark text-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo and description */}
          <div>
            <Link to="/" className="inline-flex items-center gap-2 mb-4">
              <span className="font-bold text-xl">RedFlags</span>
            </Link>
            <p className="text-white/70 mb-4">
              Empowering job seekers with insights about potential employers.
            </p>
            
            {/* Social links */}
            <div className="flex space-x-4 mt-4">
              {socialLinks.map(link => <a key={link.platform} href={link.url} target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors" aria-label={link.platform}>
                  {link.icon}
                </a>)}
            </div>
          </div>
          
          {/* Quick links column 1 */}
          <div>
            <h3 className="font-medium text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {pageLinksColumnOne.map(link => <li key={link.path}>
                  {link.path.startsWith('http') ? (
                    <a href={link.path} target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors">
                      {link.name}
                    </a>
                  ) : (
                    <Link to={link.path} className="text-white/70 hover:text-white transition-colors">
                      {link.name}
                    </Link>
                  )}
                </li>)}
            </ul>
          </div>
          
          {/* Quick links column 2 */}
          <div>
            <h3 className="font-medium text-lg mb-4">Around the Web</h3>
            <ul className="space-y-2">
              {pageLinksColumnTwo.map(link => <li key={link.path}>
                  <Link to={link.path} className="text-white/70 hover:text-white transition-colors">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>
          
          {/* Account links */}
          <div>
            <h3 className="font-medium text-lg mb-4">User Access</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/login" className="text-white/70 hover:text-white transition-colors">
                  Log in
                </Link>
              </li>
              <li>
                <Link to="/recruiter-login" className="text-white/70 hover:text-white transition-colors">
                  Recruiter Log In
                </Link>
              </li>
              <li>
                <Link to="/company-login" className="text-white/70 hover:text-white transition-colors">
                  Company Log In
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-white/20 mt-8 pt-8 text-center text-white/60 text-sm">
          <p>© {new Date().getFullYear()} RedFlags. All rights reserved.</p>
        </div>
      </div>
    </footer>;
};
export default Footer;
